import React from 'react'
import config from '../config';

export default function VideoItem({ video_id, title }) {
    return (
        <div>
            <iframe
                id={video_id}
                name={video_id}
                className='flex w-full rounded-lg aspect-video min-w-80 h-45 object-cover'
                src={config.videoEmbedUrl.replace("video_id", video_id)}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </div>
    )
}
